import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDirectionArrowDown16 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M8.15137 16C8.15137 13.0873 5.54773 10.7236 2.33319 10.7236" stroke="currentColor" /><path d="M13.9697 10.7236C10.7552 10.7236 8.15154 13.0873 8.15154 16" stroke="currentColor" /><path d="M8.15137 0L8.15137 16" stroke="currentColor" /></svg>;
const ForwardRef = forwardRef(SvgDirectionArrowDown16);
export default ForwardRef;